/**
 * A path with the embed's query string carried onto it. The query string holds the embed's
 * whole configuration (the hash session, `rooftopId`, `readOnly`, the branding params), so every
 * in-app navigation keeps it. A path that already has its own query (`?openChat=true`) gets the
 * embed's parameters joined on with `&` rather than a second `?`.
 */
export function appendSearch(path: string, search: string): string {
  const params = search.startsWith('?') ? search.slice(1) : search;
  if (!params) return path;
  return `${path}${path.includes('?') ? '&' : '?'}${params}`;
}
